module.exports = __webpack_public_path__ + "media/images/emblems/Donneloye-coat_of_arms-b0de6ce7e60fc56bd9f4b041cf76d67c.svg";